<template>
    <y-panel
        :title="$t('cart.payment_path.title')"
        raised
        class="m-cart__payment-path"
    >
        <y-loading
            :active="$wait.is('loading-payment-path')"
            position="relative"
            height="96px"
        >
            <y-radio
                v-model="selectedPaymentOption"
                color="primary"
                :options="paymentOption"
                :port="false"
                no-label
            />
            <template v-if="selectedPaymentOption === 'online'">
                <ul
                    v-if="paymentList && paymentList.length"
                    class="list"
                >
                    <li
                        v-for="payment in paymentList"
                        :key="payment.id"
                        class="payment-item"
                        :class="{'selected' : isSelected(payment)}"
                    >
                        <label>
                            <div class="image">
                                <img
                                    v-if="payment.logo"
                                    :src="payment.logo.link"
                                    :alt="payment.title"
                                >
                                <img
                                    v-else
                                    src="@/modules/cart/assets/images/shipping.svg"
                                    :alt="payment.title"
                                >
                            </div>
                            <h4
                                v-if="payment.title"
                                class="title"
                            >
                                {{ payment.title }}
                            </h4>
                            <input
                                :id="payment.id"
                                v-model="selectedPayment"
                                type="radio"
                                :value="payment"
                                class="input"
                                name="paymentGroup"
                            >
                        </label>
                    </li>
                </ul>

                <y-empty
                    v-else
                    no-image
                    no-title
                    :text="$t('cart.payment_path.empty')"
                />
            </template>
        </y-loading>
    </y-panel>
</template>

<script>
    import { YEmpty, YPanel, YRadio } from '@components';
    import { separated } from '@nodes/helpers/number';

    export default {
        name: 'PaymentPath',

        components: {
            YEmpty,
            YPanel,
            YRadio,
        },

        props: {
            /**
             * List of available payment path
             */
            paymentList: {
                type: Array,
            },

            /**
             * Disable section
             */
            disabled: {
                type: Boolean,
            },

            /**
             * Wallet
             */
            wallet: {
                type: Object,
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                selectedPayment      : null,
                selectedPaymentOption: null,
            };
        },

        computed: {
            /**
             * return payment option
             *
             * @returns {Array}
             */
            paymentOption() {
                return [
                    // TODO We can't use wallet now
                    // {
                    //     label   : this.$t('cart.payment_path.wallet', [separated(this.wallet?.balance || 0, this.$i18n.locale)]),
                    //     value   : 'wallet',
                    //     disabled: !this.wallet?.balance,
                    // },
                    {
                        label  : this.$t('cart.payment_path.online'),
                        hint   : this.$t('cart.payment_path.online_hint'),
                        value  : 'online',
                        checked: true,
                    },
                ];
            },
        },

        watch: {
            paymentList: {
                /**
                 * Reset Selected payment
                 *
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                handler(newValue, oldValue) {
                    if (!this.isEqual(oldValue, newValue)) {
                        this.selectedPayment = null;
                    }
                },
            },
            
            selectedPayment: {
                /**
                 * Emit Selected payment
                 *
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                handler(newValue, oldValue) {
                    if (!this.isEqual(oldValue, newValue)) {
                        this.$emit('selectedPayment', newValue);
                    }
                },
            },

            selectedPaymentOption: {
                /**
                 * Reset Selected payment
                 *
                 * @param {*} newValue
                 * @param {*} oldValue
                 */
                handler(newValue, oldValue) {
                    if (!this.isEqual(oldValue, newValue)) {
                        this.selectedPayment = null;
                        if (newValue === 'wallet') {
                            this.selectedPayment = this.wallet;
                        }
                    }
                },
            },
        },

        methods: {
            separated,

            /**
             * Add Style on selected payment
             * 
             * @param {object} payment
             * @returns {boolean}
             */
            isSelected(payment) {
                return this.selectedPayment?.id === payment.id;
            },
        },
    };
</script>
